import { RoundedCountryFlag } from "./RoundedCountryFlag";

export default function BadgeWithFlag({
  flagCode,
  title,
}: {
  flagCode: string;
  title: string;
}) {
  return (
    <div className="flex flex-row gap-1 rounded-full items-center bg-[#353535] border border-[#474545] px-2 pr-3 py-1">
      <div className="relative flex items-center">
        <RoundedCountryFlag
          alpha_2={flagCode}
          className="h-6 w-6 rounded-full"
        />
        <div className="h-6 w-6 absolute inset-0 shadow-[inset_0_2px_3px_rgba(0,0,0,0.5)] rounded-full" />
      </div>
      <div>{title}</div>
    </div>
  );
}
